import React from 'react';

import { Grid } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { MeshSelect, StyledTextField, noMarginSelectStyles } from 'styles/admin';

import theme from 'constants/theme';

const SearchSurveys = ({ onSearchChange, dropdownValues = [], onDropdownChange }) => {
  const dropdownValueWithEmptyOption = [{ label: 'All', value: '' }, ...dropdownValues];
  return (
    <SearchGrid
      container
      alignItems="center"
      style={{ borderBottom: `1px solid ${theme.palette.borders.lighterGrey}` }}
    >
      <Grid item xs={7}>
        <StyledTextField
          fullWidth
          style={{ width: '90%' }}
          type="text"
          name="searchText"
          margin="dense"
          variant="outlined"
          placeholder="Search templates"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize="small" style={{ color: theme.palette.icons.grey }} />
              </InputAdornment>
            ),
          }}
          onChange={(e) => onSearchChange(e.target.value, e)}
        />
      </Grid>
      <Grid item xs={5}>
        <StyledMeshSelect
          classNamePrefix="select"
          placeholder="Created by"
          isDisabled={dropdownValues.length === 0}
          onChange={(data) => onDropdownChange(data.value)}
          name="department"
          options={dropdownValueWithEmptyOption}
          styles={noMarginSelectStyles}
        />
      </Grid>
    </SearchGrid>
  );
};

const SearchGrid = styled(Grid)`
  padding: 1rem 1.5rem 1rem 1.5rem;
`;

const StyledMeshSelect = styled(MeshSelect)`
  margin-top: 3%;
  .select__control {
    min-height: 40px;
  }
`;

export default withRouter(SearchSurveys);
